import React, { useEffect, useState } from "react";
import { navigate } from "@reach/router"
import { ThemeContext, ActionContext, UserContext, LanguageContext } from "../contexts/Context";
import styled from "@emotion/styled";
import Modal from "../newcomponents/optioncomponents/Modal";
import axios from "axios";
import Loader from "react-loader-spinner";
import SelectItemModal from '../newcomponents/InitFlowComponents/SelectItemModal';
import MultiItemModal from '../newcomponents/InitFlowComponents/MultiItemModal';

// import initFlow from './InitFlowList';
const InitFlow = () => {

    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const { initFlow } = React.useContext(UserContext);

    const { lanIndex, hasCategoryScreen, hasInitFlow, initCart, isDemo, token, userId, orderTime, adCustomer, customer, pm, pax } = React.useContext(UserContext);
    const { updateDuration, updateTitle, initFlowCheck, clearInitCart, addPromotion } = React.useContext(ActionContext);
    const [loading, setLoading] = useState(true);
    const [sh, setSh] = useState(false);
    const [error, setError] = useState([]);
    const [index, setIndex] = useState(0);


    useEffect(() => {
      
        let token = localStorage.getItem("token");
        let menu = localStorage.getItem("TITLE");
        updateTitle(menu);
        
        if (!token) return;
        setLoading(false);
        axios.get(
            `/v2/api/selfOrder/check/initFlow?menu=${menu}`,
            { headers: { Authorization: "Bearer " + token } }
        )
            .then(function (response) {
                if (!response.data.hasInitFlow) {
                    //let it start
                    setLoading(false);
                } else if (response.data.hasExpired) {
                    //show error
                    let errorMessages = [];
                    errorMessages.push({
                        errorElement: "Time's up",
                        errorMessage: (
                            <>
                                <b style={{ color: "#CF000D" }}>Time's up</b>
                                you’ve exceeded the session limit.
                            </>
                        ),
                    });
                    setError(errorMessages);
                    setSh(true)
                } else {
                    if (response.data.hasDuration) {
                        updateDuration({
                            duration: response.data.duration,
                            hasDuration: response.data.hasDuration,
                            orderTime: response.data.orderTime,
                        });
                    }
                    initFlowCheck(true);
                    //navigate to menu
                    if (hasCategoryScreen)
                        navigate("/category");
                    else
                        navigate("/menu");
                }

            })
            .catch(function (response) {
                // handle error
               
            });
        //remove
        localStorage.removeItem("order");
    }, []);

    useEffect(() => {

        if (initFlow && index >= initFlow.length) {
  
            sendOrder();
        }
    }, [index]);

    const handleCallBack = (index) => {
        setIndex(index + 1);
        //submit if complete
    }
    const sendOrder = async () => {
        if (isDemo) return;
        let order = {
            pax,
            data: initCart,
            orderId: "SO_" + new Date().getTime(),
            customerName: "",
            phone: "",
            userId: userId,
            scheduleTime: 0,
            address: "",
            remark: "",
            checkbox: [],
            deliveryType: 0,
            deliveryPrice: 0,
            adCustomer: adCustomer,
            roomNo: "",
            customer: customer,
            reserveId: "",
            vouchers: []

        }

        await axios.post("/v2/api/selfOrder/order", order, { headers: { Authorization: "Bearer " + token } })
            .then(async function (response) {
                await axios.get(`/v2/api/selfOrder/order?userId=${userId}&orderTime=${orderTime}&orderId=${order.orderId}`,
                    { headers: { Authorization: "Bearer " + token } }
                );
            })
            .then(function (response) {
                // handle success
                localStorage.setItem("orderId", order.orderId);
                clearInitCart();
                setLoading(false);
                let newPromo = pm;
                newPromo = newPromo.filter((p) => !p.isVoucher);
                addPromotion(newPromo);
                // if (hasCategoryScreen)
                //     navigate("/category");
                // else
                    navigate("/menu");
            })
            .catch(function (response) {
                // handle error
                navigate('/order/fail');
          
            });
    }
    const startFlow = () => {
        if (index <= initFlow.length - 1) {
            return (
                initFlow[index].stockItem.length == 1 ?
                    <SelectItemModal
                        show={true}
                        flow={initFlow[index]}
                        item={initFlow[index].stockItem[0]}
                        index={index}
                        cart={initCart}
                        isEdit={false}
                        handleCallBack={handleCallBack}
                    /> :
                    <MultiItemModal
                        show={true}
                        flow={initFlow[index]}
                        index={index}
                        cart={initCart}
                        handleCallBack={handleCallBack}
                    />
            )
        }
    }

    if (typeof lanIndex === 'undefined' || loading) {
        return <LoaderContainer>
            <Loader
                type="ThreeDots"
                color={themeContext.primaryColor}
                height="100"
                width="100"
            />
        </LoaderContainer>
    }
    return (
        <React.Fragment>
            <Wrapper themeContext={themeContext}>
                {startFlow()}
                <Modal show={sh} setShow={setSh} error={error} />
            </Wrapper>
        </React.Fragment>
    );


}

export default InitFlow;
const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  max-width: 550px;
  background-color: ${(props) => props.themeContext.backgroundColor};
  overflow-y: scroll;
  z-index: -10;
`;
const LoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  place-content: center;
`;

